import React from 'react';
import Navbar from '../components/navbar';


export default function Contact() {
  return (
    <>
    <Navbar/>
    <div className="contact_container">
    <nav aria-label="breadcrumb">
  <ol className="breadcrumb">
    <li className="breadcrumb-item " aria-current="page">Home</li>
    <li className="breadcrumb-item active" aria-current="page">Contact</li>
  </ol>
</nav>
    </div>

    </>
  )
}
